import React, { useState } from "react"
import { Container, Row, Col } from "reactstrap"
import TaskList from "../../TaskManagement/TaskList"
import TaskManagementListHeader from "../../TaskManagement/TaskManagementListHeader"
import "./TasksTab.css"


const TasksTab = ({ incidentId }) => {
    const [orderBy, setOrderBy] = useState(['-date_added'])
    const [filterValues, setFilterValues] = useState({ searchTerm: '', statuses: ['OPEN', 'IN PROGRESS'], incidentId: incidentId, isArchived: false })
    const boardId = process.env.NODE_ENV === "production" ? "Qm9hcmROb2RlOjY=" : process.env.NODE_ENV === "staging" ? "Qm9hcmROb2RlOjc=" : "Qm9hcmROb2RlOjE="

    return (
        <Container fluid className="incident-tasks-container">
            <div className="info-container mt-0">
                <TaskManagementListHeader activeTab="all" parentBoardId={boardId} filterValues={filterValues} setFilterValues={(res) => setFilterValues({ ...res })} />
                <Row>
                    <Col className="TaskListColumn">
                        <TaskList parentBoardId={boardId} {...filterValues} orderBy={orderBy} />
                    </Col>
                </Row>
            </div>
        </Container>
    )
}

export default TasksTab